import styled from 'styled-components';
import { DatePicker } from 'antd';
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const MyDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);

export const StyledDatePicker = styled(MyDatePicker)`
  width: 100%;
  height: 40px;
  font-size: 16px;
  border-radius: 8px;
  border-color: ${({ theme }) => theme.palette.neutral[300]} !important;

  &:not(.ant-picker-disabled):hover,
  &:not(.ant-picker-disabled):focus,
  &:not(.ant-picker-disabled):focus-within {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
  }

  &.ant-picker-disabled {
    .ant-picker-input > input {
      color: ${({ theme }) => theme.palette.text.primary} !important;
      -webkit-text-fill-color: ${({ theme }) =>
        theme.palette.text.primary} !important;
    }

    &:hover,
    &:focus,
    &:focus-within {
      border-color: ${({ theme }) => theme.palette.neutral[300]} !important;
    }
  }
`;
